import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { HttpClient } from "@angular/common/http";

import { AbstractService } from "./abstract.service";
import { ImovelResponseDto } from "../dto/imovel-response.dto";
import { PaginationResultDto } from "../dto/pagination-result.dto";

@Injectable({ providedIn: 'root' })
export class ImovelService extends AbstractService {

    private readonly URL = `${this.API_REST}/imovel/`

    constructor(http: HttpClient) {
        super(http);
    }

    async getImovelById(codigo: string) : Promise<ImovelResponseDto> {
        const response$ = this.http.get<ImovelResponseDto>(this.URL + codigo);
        return await firstValueFrom(response$);
    }

    async getImovelSemelhanteById(codigo: string) : Promise<PaginationResultDto<ImovelResponseDto>> {
        const urlFinal = this.URL + `${codigo}/semelhantes`;

        const response$ = this.http.get<PaginationResultDto<ImovelResponseDto>>(urlFinal);
        return await firstValueFrom(response$);
    }
}   